module.exports = __webpack_public_path__ + "img/hauskraeutchesgarten_1.8427d49e.jpg";